import { getWidthPercents } from '../utils';

export const Empty = () => (index: number) => `
<mj-column width="${getWidthPercents(index)}" background-color="#fff">
    
</mj-column>
`;
